import template from './index.html'
import { fapp } from '../../fapp'

const pageDevices = () => {
  return {
    transitionEffect: false,
    root: null,
    title: 'МОИ УСТРОЙСТВА',
    login: '',
    password: '',
    error: '',
    async init() {
      this.root = this
      this.context.body = template
      this.updateDevices()
    },
    async updateDevices() {
      try {
        const devices = await fapp.service('/api/devices').find({ query: { $include: ['cameras'], $paginate: 'false'}})
        this.$store.state.devices = devices
      } catch(e) {
      }
    },
    goDevice(device) {
      if (!device.isOnline) return
      this.app.context.device = device
      this.app.goPage('device')
    },
    openMenu() {
      this.app.showMenu = true
    }
  }
}

export { pageDevices }
